<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
      :model="info"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="直播类型">
        <el-radio-group v-model="info.live_type" @change="liveTypeChange">
          <el-radio :label="1" :disabled="info.id > 0 ? true : false">常规直播</el-radio>
          <el-radio :label="4" :disabled="info.id > 0 ? true : false">推流直播</el-radio>
          <el-radio :label="6" :disabled="info.id > 0 ? true : false">伪直播<strong style="color: red;">（伪直播开始时间必须在当前时间一小时后，并且距开始一小时内不能更新关联的视频，直播时长设置接近所选视频时长）</strong>
          </el-radio>

          <el-radio :label="7" :disabled="info.id > 0 ? true : false"><strong>小鹅通直播</strong></el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="竖屏带货">
        <el-radio-group v-model="info.configuration.is_vertical_screen">
          <el-radio :label="0" :disabled="info.id > 0 ? true : false">否</el-radio>
          <el-radio :label="1" :disabled="info.id > 0 ? true : false">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="info.live_type == 6" :label="info.configuration.mock_course_period_type != 4 ? '视频' : '回放'">
        <el-input
            v-model="info.configuration.mock_course_period_title"
            placeholder="请选择"
            :disabled="true"
            style="width:80%"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          :disabled="info.id > 0 ? true : false"
          @click="
            search.chooseOrgVisible = true;
            searchData();
          "
        >
          查询
        </el-button>
      </el-form-item>

      <el-form-item label="标题">
        <el-input
          v-model="info.title"
          maxlength="30"
          show-word-limit
          style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="开课时间">
        <el-date-picker
          :disabled="info.have_copy_period > 0"
          v-model="info.begin_day"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
        &nbsp;
        <el-time-picker
          :disabled="info.have_copy_period > 0"
          is-range
          format = 'HH:mm' 
          value-format = 'HH:mm'
          v-model="info.begin_time"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围">
        </el-time-picker>
        &nbsp;
        <i class="el-icon-warning" @click="showMsg()"></i>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
          v-model="info.released_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择发布时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="百家云虚拟人数">
        <el-input type="number" v-model="info.configuration.bjy_virtual_person_num" style="width:33%" :disabled="info.have_copy_period > 0"></el-input>
        &nbsp;
        <i class="el-icon-warning" @click="showMsg()"></i>
      </el-form-item>
      <el-form-item label="灵动生活虚拟人数">
        <el-input type="number" v-model="info.configuration.virtual_study_number" style="width:33%" :disabled="info.have_copy_period > 0"></el-input>
        &nbsp;
        <i class="el-icon-warning" @click="showMsg()"></i>
      </el-form-item>

      <el-form-item label="主讲区域" v-if="!info.configuration.is_vertical_screen">
        <el-checkbox v-model="info.configuration.chat" disabled>聊天</el-checkbox>
        <el-checkbox v-model="info.configuration.faqs">问答</el-checkbox>
        <el-checkbox v-model="info.configuration.kejian">课件</el-checkbox>
      </el-form-item>

      <el-form-item label="免费试看">
        <el-radio-group v-model="info.is_free">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1" >是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="直播间人数">
        <el-radio-group v-model="info.configuration.show_user_num">
          <el-radio :label="1">正常展示</el-radio>
          <el-radio :label="0">不展示</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="非会员看回放">
        <el-radio-group v-model="info.general_auth">
          <el-radio :label="0">不允许</el-radio>
          <el-radio :label="1">允许</el-radio>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="伪直播消息来源" v-if="info.live_type == 6 && info.configuration.mock_course_period_type == 4">
        <el-radio-group v-model="info.configuration.mock_live_msg_source" :disabled="info.id > 0 ? true : false">
          <el-radio :label="0">回放原消息（不需要手动拉取，直播时百家云自动重放原直播聊天）</el-radio>
          <el-radio :label="1">手动拉取</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="选择习题">
        <el-select v-model="info.exercise_question_id" filterable placeholder="不选择习题" clearable :disabled="selectQuestionAble">
          <el-option
              v-for="item in this.exercise_question_list"
              :key="item.id"
              :label="item.text"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="createUpdate()"
          :loading="updateLoading"
          >确 定</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择"
      :visible.sync="search.chooseOrgVisible"
      :modal="false"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.title"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            class="search-el"
            size="mini"
            v-model="search.query.is_vertical_screen"
            clearable
            placeholder="全部直播"
          >
            <el-option label="全部直播" value="0">全部直播</el-option>
            <el-option label="竖屏直播" value="1">竖屏直播</el-option>
            <el-option label="普通直播" value="2">普通直播</el-option>      
          </el-select>  
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchData()">
            查询
          </el-button>
          <el-button type="primary" size="mini" @click="addPeriodVideo()">
            添加伪直播视频
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        size="mini"
      >
        <el-table-column
          label="小节标题"
          align="center"
          min-width="20%"
        >
          <template slot-scope="{ row }">
            {{ "【小节ID： " + row.id + "】&nbsp;" + row.title }}
          </template>
        </el-table-column>

        <el-table-column
          label="主课"
          align="center"
          min-width="20%"
        >
          <template slot-scope="{ row }">
            <div v-if="row.course_type == 1">{{ "【线上课ID： " + row.course_id + "】&nbsp;" + row.course_title }}</div>
            <div v-else>{{ "【直播课ID： " + row.course_id + "】&nbsp;" + row.course_title }}</div>
          </template>
        </el-table-column>

        <el-table-column label="类别" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div v-if="row.type == 2">百家云点播视频</div>
            <div v-if="row.type == 4 && row.live_type == 1">常规直播回放</div>
            <div v-if="row.type == 4 && row.live_type == 4">推流直播回放</div>
            <div v-if="row.type == 4 && row.live_type == 6">伪直播回放</div>
          </template>
        </el-table-column>

        <el-table-column
          label="直播时间"
          align="center"
          min-width="12%"
          prop="begin_at"
        >
        </el-table-column>
        
        <el-table-column
          label="时长"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            {{ durationShow(row.duration) }}
          </template>
        </el-table-column>

        <el-table-column
          label="回放/视频ID"
          align="center"
          min-width="12%"
          prop="bjy_video_id"
        >
        </el-table-column>

        <el-table-column
          label="竖屏直播"
          align="center"
          min-width="6%"
        >
        <template slot-scope="{ row }">
            {{ row.is_vertical_screen == '1' ? '是' : '否' }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  formatSeconds,
  formatDate,
} from "@/api/common";
import { createdUpdatePeriod, getPeriodDetail, searchBJYVideoList, createELive, getCourseInfo,getExerciseQuestions } from "@/api/live";

export default {
  data: function () {
    return {
      isshow: false,
      loading: false,
      updateLoading: false,
      selectQuestionAble: false,
      exercise_question_list: false,
      info: {
        id: this.$route.query.id || 0,
        course_id: this.$route.query.course_id || 0,
        course_term_id: this.$route.query.course_term_id || 0,
        live_type: 1,
        title: "",
        released_at: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        begin_day: formatDate(new Date(), 'yyyy-MM-dd'),
        begin_time: [formatDate(new Date(
          (new Date()).setMinutes(
            (new Date()).getMinutes() + 5
          )
        ), 'hh:mm'), "23:59"],
        configuration: {
          detail: false,
          chat: true,
          faqs: false,
          kejian: false,
          mock_course_period_id: 0,
          mock_course_period_type: 4,
          mock_course_period_title: '',
          mock_bjy_video_id: 0,
          is_vertical_screen: 0,//是否是竖屏直播，1-是，0-否
          virtual_study_number: 99,
          show_user_num: 1, //是否正常显示直播间人数，1-显示，0-隐藏
          mock_live_msg_source: 0, //伪直播消息来源，0-回放原消息（不需要手动拉取，直播时百家云自动重放原直播聊天），1-手动拉取
          bjy_virtual_person_num: 99,
        },
        is_free: 0,
        general_auth: 0, //普通用户观看回放权限，0-不允许，1-允许
        have_copy_period: 0, //该小节是否有复制的
        exercise_question_id: '', //关联的习题
      },

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          title: "",
          filterPeriodIds: [],
          page: 1,
          limit: 5,
          is_vertical_screen: ''
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  created: function () {
    if (this.info.id > 0) {
      this.getInfo();
    } else {
      this.getCourseInfo();
    }
    this.getExerciseQuestions();
  },
  mounted() {},
  methods: {
    showMsg() {
      this.$message({
          showClose: true,
          message: "该直播小节属于复制的，在 大直播课编辑即可",
          type: "warn",
        });
    },
    liveTypeChange() {
      if (this.info.live_type == 7) {
        this.$prompt("请输入小鹅通直播ID", "拉取小鹅通直播", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^l_[0-9a-zA-Z]{24}$/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          createELive({
            course_id: this.info.course_id,
            term_id: this.info.course_term_id,
            resource_id: value,
          }).then((response) => {
            if (response.status == 2000) { 
              this.$message({
                showClose: true,
                message: response.message,
                type: "success",
                duration: 8 * 1000
              });
              this.ref();
            } else {
              this.info.live_type = 1
            }
          });
        })
        .catch(() => {
          console.log('取消')
          this.info.live_type = 1
        });
      }
      else if (this.info.live_type == 6) {
        // this.info.begin_time = [formatDate(new Date(
        //   (new Date()).setHours(
        //     (new Date()).getHours() + 1,
        //     (new Date()).getMinutes() + 5
        //   )
        // ), 'hh:mm'), "23:59"]

        //伪直播开播时间默认19:30~21:00
        this.info.begin_time = ['19:30', "21:00"]
      } else {
        this.info.begin_time = [formatDate(new Date(
          (new Date()).setMinutes(
            (new Date()).getMinutes() + 5
          )
        ), 'hh:mm'), "23:59"]
      }
    },
    addPeriodVideo() {      
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=course&m=periodList&p=31&id=13601', '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=course&m=periodList&p=31&id=13601', '_blank');
      }
    },
    selectProduct(row) {
      this.info.configuration.mock_course_period_id = row.id;
      this.info.configuration.mock_course_period_type = row.type;
      this.info.configuration.mock_course_period_title = row.title + ' 【时长：' + formatSeconds(row.duration) + '】'+ ' 视频ID：' + row.bjy_video_id;
      this.info.configuration.mock_bjy_video_id = row.bjy_video_id;

      this.addEditFormOnClose();
    },
    durationShow(duration) {
      return formatSeconds(duration);
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.title = "";
      this.search.query.filterPeriodIds = [];

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      this.search.listLoading1 = true;
      this.search.query.filterPeriodIds = this.search.query.filterPeriodIds.toString();
      searchBJYVideoList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },

    getCourseInfo() {
      this.loading = true;
      getCourseInfo({
        course_id: Number(this.info.course_id),
      }).then((response) => {
        this.info.configuration.bjy_virtual_person_num = response.data.teacher_id == 2 ? 0 : 99;
        this.loading = false;
      });
    },
    getInfo() {
      this.loading = true;
      getPeriodDetail({
        id: Number(this.info.id),
      }).then((response) => {
        console.log(response.data)
        if(response.data.exercise_question_id>0){
          this.selectQuestionAble = true;
        }
        this.info = response.data;
        this.loading = false;
      });
    },
    createUpdate() {
      this.updateLoading = true;
      createdUpdatePeriod(this.info)
        .then((response) => {
          this.updateLoading = false;
          if (response.code == 1) {
            this.$message.success(response.message);
            this.info.id = response.data.id;
          }
        })
        .catch((err) => {
          this.updateLoading = false;
        });
    },
    getExerciseQuestions() {
      getExerciseQuestions({target_id:this.info.course_id,object_id:this.info.id})
          .then((response) => {
            if (response.code == 1) {
              this.exercise_question_list = response.data;
            }
          })
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>

</style>